module.exports = __webpack_public_path__ + "285f1200cfe90a012544b977bc045dd7.mp3";


//////////////////
// WEBPACK FOOTER
// ./assets/sounds/background/forest.mp3
// module id = 3260
// module chunks = 0